// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://instalpego.nbg1.your-objectstorage.com/public';
const server = "https://apiinstalpego.mansolutions.app";
const port = 443;
const domain = "instalpego.mansolutions.app";
export { server, port, domain, serverImg };
